const page_title ={"status":true,"data":{"page_title_setting":{"label":"品牌","font":"Arimo","font_size":38,"font_bold":true,"color":"#000000"},"url_key":"brands","meta_title":"品牌","meta_keywords":"品牌","meta_description":"String","featured_brand":0,"search_box":0,"brand_list":1,"alphabet_list":1,"_id":"5f9795e7aaf80c2c4b695f47","shop_id":"5f9795e7aaf80c2c4b695f3b","createdAt":"2020-10-27T03:37:11.321Z","updatedAt":"2020-10-28T02:58:23.159Z"}};const setting ={"status":true,"data":{"featured_brand_setting":{"_id":"5f9795e7aaf80c2c4b695f43","general_setting":{"background":"#ffffff","border_size":0,"border_color":"#ffffff","margin_top":50,"margin_bottom":25,"padding_top":15,"padding_right":0,"padding_bottom":20,"padding_left":0},"title_setting":{"label":"Feature brand","font":"Poppins","font_size":18,"color":"#3a4892","font_bold":true,"align":3,"margin_top":0,"margin_bottom":10,"border_size":0,"border_color":"#515482","border_margin":0},"brand_setting":{"limit":10,"brand_per_row":5,"brand_per_row_mobile":5,"brand_per_row_tablet":5,"image_width":200,"image_height":200,"hover_efect":"effect-3","use_slider":true,"slide_by":1,"rtl":true,"margin":30,"autoplay":true,"autoplay_timeout":"1000","mouseover_stop":"string","loop":true,"display_navigation":true,"hide_navigation":false,"navigation_position":1,"navigation_size":35,"navigation_color":"#e9ecef","navigation_hover_color":"#5d6cc1","display_Pagination":false,"pagination_width":12,"pagination_height":12,"pagination_border_radius":7,"pagination_color":"#e9ecef","pagination_active_color":"#5d6cc1","pagination_margin":30,"pagination_margin_top":50},"brand_name_setting":{"display":true,"font":"Poppins","font_size":14,"color":"#000000","position":1,"background":"#000000","background_opacity":0.4,"auto_hide":false,"text_align":1,"margin_top":10,"margin_bottom":0,"display_product_count":0,"pc_text_format":" (%s products)","pc_font_size":14,"pc_color":"#5f5c5c","pc_position":2},"position":1,"visible":false,"shop_id":"5f9795e7aaf80c2c4b695f3b","created_at":"2020-10-27T03:37:11.244Z","updated_at":"2020-10-28T02:58:23.286Z"},"search_box_setting":{"_id":"5f9795e7aaf80c2c4b695f44","general_setting":{"background":"#ffffff","border_size":1,"border_color":"#ffffff","border_radius":0,"margin_top":40,"margin_bottom":40,"padding_top":25,"padding_right":20,"padding_bottom":30,"padding_left":20,"content_align":2},"title_setting":{"label":"品牌搜尋","font":"Poppins","font_size":18,"color":"#000000","font_bold":true,"align":3,"margin_top":0,"margin_bottom":20,"border_size":0,"border_color":"#ffffff","border_margin":0},"search_input_setting":{"placeholder":"輸入...","color":"#000000","font_size":16,"background":"#e7e7e7","padding_top":20,"padding_right":40,"padding_bottom":20,"padding_left":40,"margin_top":0,"margin_right":0,"margin_bottom":0,"margin_left":0,"border_size":0,"border_color":"#b66a6a","border_radius":30},"search_suggest_setting":{"background":"#ffffff","hover_background":"#e6f4ff","box_shadow":"0px 20px 45px 0px rgba(19, 25, 59, 0.1)","bottom":10,"show_brand_image":true,"image_width":150,"image_height":150,"image_margin":20,"show_brand_name":true,"br_font":"Poppins","br_font_size":18,"br_color":"#2d2e2f","br_font_bold":true,"br_uppercase":false,"br_margin_top":0,"br_margin_bottom":0,"show_short_description":true,"sd_font":"Poppins","sd_font_size":14,"sd_color":"#2d2e2f","sd_margin_top":10,"sd_margin_bottom":0,"divider_color":"#ffffff","padding_top":20,"padding_bottom":20},"position":2,"visible":false,"shop_id":"5f9795e7aaf80c2c4b695f3b","created_at":"2020-10-27T03:37:11.251Z","updated_at":"2020-10-28T02:58:23.287Z"},"brand_list_setting":{"_id":"5f9795e7aaf80c2c4b695f45","general_setting":{"margin_top":20,"margin_bottom":20,"limit":10,"brand_per_row":5,"brand_per_row_mobile":5,"brand_per_row_tablet":5,"image_width":155,"image_height":155,"hover_effect":"effect-1","ajax_load":true,"load_limit":4,"loadmore_text":"View More","loadmore_font":"Poppins","loadmore_font_size":14,"loadmore_color":"#ffffff","loadmore_hover_color":"#ffffff","loadmore_font_bold":false,"loadmore_background":"#5d6cc1","loadmore_hover_background":"#6886d8","loadmore_border_color":"#5d6cc1","loadmore_border_hover_color":"#6886d8","loadmore_border_size":1,"loadmore_padding_top":10,"loadmore_padding_right":20,"loadmore_padding_bottom":10,"loadmore_padding_left":20,"loadmore_border_radius":3,"loadmore_margin_top":25,"loadmore_margin_bottom":1},"title_setting":{"label":"","font":"Poppins","font_size":18,"font_color":"#3a4892","font_bold":true,"align":3,"margin_top":0,"margin_bottom":0,"border_size":0,"border_color":"#ffffff","border_margin":0},"brand_name_setting":{"font":"Poppins","font_size":14,"color":"#2d2c45","position":1,"background":"#000000","background_opacity":0.3,"auto_hide":true,"text_align":1,"margin_top":10,"margin_bottom":1,"display_product_count":1,"pc_text_format":"%s products","pc_font_size":17,"pc_color":"#000000","pc_position":2},"position":3,"visible":true,"shop_id":"5f9795e7aaf80c2c4b695f3b","createdAt":"2020-10-27T03:37:11.280Z","updatedAt":"2020-10-28T02:58:23.286Z"},"alphabet_list_setting":{"_id":"5f9795e7aaf80c2c4b695f46","general_setting":{"margin_top":100,"margin_bottom":60,"alphabet":"A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,X,Y,W","character_per_row":1,"brand_per_row":5,"brand_per_row_mobile":5,"brand_per_row_tablet":5,"brand_per_character":10,"viewmore_text":"View More","viewmore_color":"#c98a8a","viewmore_hover_color":"#c91c1c"},"title_setting":{"label":"Brand Names by Alphabet","font":"Poppins","font_size":18,"color":"#3a4892","font_bold":true,"uppercase":false,"align":3,"margin_top":25,"margin_bottom":10,"border_size":0,"border_color":"#ffffff","border_margin":0},"character_setting":{"font":"PT Serif","font_size":20,"color":"#374b5d","margin_top":60,"margin_bottom":10},"brand_link_setting":{"font":"Roboto","font_size":15,"color":"#374b5d","hovercolor":"#8abbe6","line_height":15},"position":4,"visible":true,"shop_id":"5f9795e7aaf80c2c4b695f3b","createdAt":"2020-10-27T03:37:11.308Z","updatedAt":"2020-10-28T02:58:23.286Z"}}};const brands ={"status":true,"data":[{"_id":"5f979613aaf80c2c4b696046","products":["5f9795e7aaf80c2c4b695fee","5f9795e7aaf80c2c4b695ff1","5f9795e7aaf80c2c4b69601d","5f9795e7aaf80c2c4b695ff0","5f9795e7aaf80c2c4b69601f","5f9795e7aaf80c2c4b695f4e","5f9795e7aaf80c2c4b695f4f","5f9795e7aaf80c2c4b695f93","5f9795e7aaf80c2c4b695f92","5f9795e7aaf80c2c4b695fc1","5f9795e7aaf80c2c4b695fc0","5f9795e7aaf80c2c4b695f82","5f9795e7aaf80c2c4b695f7d","5f9795e7aaf80c2c4b695fbe","5f9795e7aaf80c2c4b695fe7","5f9795e7aaf80c2c4b695f66","5f9795e7aaf80c2c4b695f68","5f9795e7aaf80c2c4b695f69","5f9795e7aaf80c2c4b695ff7","5f9795e7aaf80c2c4b695f95","5f9795e7aaf80c2c4b695f96","5f9795e7aaf80c2c4b695fce","5f9795e7aaf80c2c4b695fcd","5f9795e7aaf80c2c4b695fe1","5f9795e7aaf80c2c4b695fed","5f9795e7aaf80c2c4b695fbc","5f9795e7aaf80c2c4b695fbb","5f9795e7aaf80c2c4b695fc9","5f9795e7aaf80c2c4b695fc2","5f9795e7aaf80c2c4b695f5a","5f9795e7aaf80c2c4b695f9d","5f9795e7aaf80c2c4b695fe9","5f9795e7aaf80c2c4b695fec","5f9795e7aaf80c2c4b695f72","5f9795e7aaf80c2c4b695f73","5f9795e7aaf80c2c4b695f63","5f9795e7aaf80c2c4b695fb7","5f9795e7aaf80c2c4b695fb9"],"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_id":{"_id":"5f979613aaf80c2c4b696045","is_feature":false,"is_disabled":false,"isDelete":false,"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_name":"BIO-LOGIC","brand_key":"bio-logic","meta_title":"","meta_keyword":"","meta_description":"","short_description":"","description":"","brand_logo":"https://brand.spify.io/shop-by-brand/media/wahatong/Bio-logic-1603769874904.jpg","brand_image":"","position":213,"createdAt":"2020-10-27T03:37:55.226Z","updatedAt":"2020-10-28T02:58:32.628Z"},"createdAt":"2020-10-27T03:37:55.231Z","updatedAt":"2020-10-27T04:55:05.053Z"},{"_id":"5f97961caaf80c2c4b696050","products":["5f9795e7aaf80c2c4b695f77","5f9795e7aaf80c2c4b695fb4","5f9795e7aaf80c2c4b695f78","5f9795e7aaf80c2c4b695f5c","5f9795e7aaf80c2c4b695fa3","5f9795e7aaf80c2c4b695f9f","5f9795e7aaf80c2c4b695fe4","5f9795e7aaf80c2c4b695fa0","5f9795e7aaf80c2c4b695fe6","5f9795e7aaf80c2c4b695fa2","5f9795e7aaf80c2c4b695fa1","5f9795e7aaf80c2c4b695f86","5f9795e7aaf80c2c4b695f58","5f9795e7aaf80c2c4b695fef"],"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_id":{"_id":"5f97961caaf80c2c4b69604f","is_feature":false,"is_disabled":false,"isDelete":false,"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_name":"COOBO","brand_key":"coobo","meta_title":"","meta_keyword":"","meta_description":"","short_description":"","description":"","brand_logo":"https://brand.spify.io/shop-by-brand/media/shop/Coobo-1603769884375.png","brand_image":"","position":214,"createdAt":"2020-10-27T03:38:04.684Z","updatedAt":"2020-10-28T02:58:36.924Z"},"createdAt":"2020-10-27T03:38:04.687Z","updatedAt":"2020-10-27T04:59:37.251Z"},{"_id":"5f979635aaf80c2c4b69605d","products":["5f9795e7aaf80c2c4b695fe8","5f9795e7aaf80c2c4b695fd5","5f9795e7aaf80c2c4b695fbd","5f9795e7aaf80c2c4b69601e","5f9795e7aaf80c2c4b695f51","5f9795e7aaf80c2c4b695f52","5f9795e7aaf80c2c4b695f80","5f9795e7aaf80c2c4b695f81","5f9795e7aaf80c2c4b695ff8","5f9795e7aaf80c2c4b695f90","5f9795e7aaf80c2c4b695f65","5f9795e7aaf80c2c4b695f9a","5f9795e7aaf80c2c4b695fc3","5f9795e7aaf80c2c4b695f6f","5f9795e7aaf80c2c4b695f70","5f9795e7aaf80c2c4b695f64","5f9795e7aaf80c2c4b695fb8","5f9795e7aaf80c2c4b695fba","5f9795e7aaf80c2c4b695f85","5f9795e7aaf80c2c4b695f5b","5f9795e7aaf80c2c4b695f97"],"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_id":{"_id":"5f979635aaf80c2c4b69605c","is_feature":false,"is_disabled":false,"isDelete":false,"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_name":"iCare's","brand_key":"icare-s","meta_title":"","meta_keyword":"","meta_description":"","short_description":"","description":"","brand_logo":"https://brand.spify.io/shop-by-brand/media/shop/iCares-1603769909006.jpg","brand_image":"","position":215,"createdAt":"2020-10-27T03:38:29.323Z","updatedAt":"2020-10-28T02:58:41.326Z"},"createdAt":"2020-10-27T03:38:29.327Z","updatedAt":"2020-10-28T02:24:22.423Z"},{"_id":"5f97963faaf80c2c4b696069","products":["5f9795e7aaf80c2c4b695f75","5f9795e7aaf80c2c4b695f79","5f9795e7aaf80c2c4b695fc4","5f9795e7aaf80c2c4b695f87"],"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_id":{"_id":"5f97963faaf80c2c4b696068","is_feature":false,"is_disabled":false,"isDelete":false,"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_name":"Kinki","brand_key":"kinki","meta_title":"","meta_keyword":"","meta_description":"","short_description":"","description":"","brand_logo":"https://brand.spify.io/shop-by-brand/media/shop/Kinki-1603769918829.png","brand_image":"","position":216,"createdAt":"2020-10-27T03:38:39.139Z","updatedAt":"2020-10-28T02:58:46.326Z"},"createdAt":"2020-10-27T03:38:39.143Z","updatedAt":"2020-10-28T02:27:11.898Z"},{"_id":"5f97964caaf80c2c4b696078","products":["5f9795e7aaf80c2c4b695f62","5f9795e7aaf80c2c4b695f9c","5f9795e7aaf80c2c4b695f9b","5f9795e7aaf80c2c4b695fb0","5f9795e7aaf80c2c4b695fb1","5f9795e7aaf80c2c4b695f76","5f9795e7aaf80c2c4b696020","5f9795e7aaf80c2c4b695fe0","5f9795e7aaf80c2c4b695fea","5f9795e7aaf80c2c4b695feb","5f9795e7aaf80c2c4b695f74","5f9795e7aaf80c2c4b695f71","5f9795e7aaf80c2c4b695f94","5f9795e7aaf80c2c4b695ff3","5f9795e7aaf80c2c4b695ff2","5f9795e7aaf80c2c4b695f50","5f9795e7aaf80c2c4b695fda","5f9795e7aaf80c2c4b695fcf","5f9795e7aaf80c2c4b695fd0","5f9795e7aaf80c2c4b695f91","5f9795e7aaf80c2c4b695f83","5f9795e7aaf80c2c4b695fdd"],"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_id":{"_id":"5f97964caaf80c2c4b696077","is_feature":false,"is_disabled":false,"isDelete":false,"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_name":"NATURALS-LIFE","brand_key":"naturals-life","meta_title":"","meta_keyword":"","meta_description":"","short_description":"","description":"","brand_logo":"https://brand.spify.io/shop-by-brand/media/shop/Naturals-life-1603769932446.jpg","brand_image":"","position":217,"createdAt":"2020-10-27T03:38:52.761Z","updatedAt":"2020-10-28T02:58:50.806Z"},"createdAt":"2020-10-27T03:38:52.764Z","updatedAt":"2020-10-28T02:38:27.306Z"},{"_id":"5f97965daaf80c2c4b696089","products":["5f9795e7aaf80c2c4b695f53","5f9795e7aaf80c2c4b695f54","5f9795e7aaf80c2c4b695f67","5f9795e7aaf80c2c4b695fc7","5f9795e7aaf80c2c4b695fc6","5f9795e7aaf80c2c4b695fc5","5f9795e7aaf80c2c4b695f5d","5f9795e7aaf80c2c4b695f7f","5f9795e7aaf80c2c4b695f7e","5f9795e7aaf80c2c4b695f55","5f9795e7aaf80c2c4b695f89","5f9795e7aaf80c2c4b695f84","5f9795e7aaf80c2c4b695fca","5f9795e7aaf80c2c4b695fcb","5f9795e7aaf80c2c4b695f8a","5f9795e7aaf80c2c4b695f6e","5f9795e7aaf80c2c4b695f6c","5f9795e7aaf80c2c4b695f6d","5f9795e7aaf80c2c4b695fcc","5f9795e7aaf80c2c4b695fde","5f9795e7aaf80c2c4b695fdf","5f9795e7aaf80c2c4b695ffb","5f9795e7aaf80c2c4b695ffd","5f9795e7aaf80c2c4b696001","5f9795e7aaf80c2c4b696004","5f9795e7aaf80c2c4b696005","5f9795e7aaf80c2c4b696008","5f9795e7aaf80c2c4b696009","5f9795e7aaf80c2c4b69600c","5f9795e7aaf80c2c4b69600f","5f9795e7aaf80c2c4b696011","5f9795e7aaf80c2c4b696013","5f9795e7aaf80c2c4b696015","5f9795e7aaf80c2c4b696017","5f9795e7aaf80c2c4b696019","5f9795e7aaf80c2c4b69601a","5f9795e7aaf80c2c4b69601b"],"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_id":{"_id":"5f97965daaf80c2c4b696088","is_feature":false,"is_disabled":false,"isDelete":false,"shop_id":"5f9795e7aaf80c2c4b695f3b","brand_name":"華夏堂","brand_key":"wahatong","meta_title":"","meta_keyword":"","meta_description":"","short_description":"","description":"","brand_logo":"https://brand.spify.io/shop-by-brand/media/shop/Wa Ha Tong-1603769949603.jpg","brand_image":"","position":218,"createdAt":"2020-10-27T03:39:09.925Z","updatedAt":"2020-10-28T02:58:54.537Z"},"createdAt":"2020-10-27T03:39:09.928Z","updatedAt":"2020-10-28T02:48:17.051Z"}]};
function get_position(inp, pos) {

    switch (pos) {
        case 1:
            // center
            inp.classList.add("aht-center");

            break;
        case 2:
            // right
            inp.classList.add("aht-right");

            break;
        case 3:
            // left
            inp.classList.add("aht-left");

            break;
              case '1':
            // center
            inp.classList.add("aht-center");

            break;
        case '2':
            // right
            inp.classList.add("aht-right");

            break;
        case '3':
            // left
            inp.classList.add("aht-left");

            break;
        default:
             inp.classList.add("aht-left");
    }
}

var brands_new = brands.data.filter(function(brand) {
  if (!brand.brand_id) {
    return false; // skip
  }
  return true;
})

var main_title = document.createTextNode(page_title.data.page_title_setting.label);
if(document.getElementById("aht-page-title")) {
  document.getElementById("aht-page-title").appendChild(main_title);
}

var sb_title = document.createTextNode(setting.data.search_box_setting.title_setting.label);
if(document.getElementById("search-box-title")) {
  document.getElementById("search-box-title").appendChild(sb_title);
  if(setting.data.search_box_setting.title_setting.font_bold) {
     document.getElementById("search-box-title").classList.add("aht-bold");
  }
  get_position(document.getElementById("search-box-title"), setting.data.search_box_setting.title_setting.align);
}

var fb_title = document.createTextNode(setting.data.featured_brand_setting.title_setting.label);

var bl_title = document.createTextNode(setting.data.brand_list_setting.title_setting.label);
if(document.getElementById("brand-list-title") != null) {
    document.getElementById("brand-list-title").appendChild(bl_title);
  if(setting.data.brand_list_setting.title_setting.font_bold) {
      document.getElementById("brand-list-title").classList.add("aht-bold");
    }
    get_position(document.getElementById("brand-list-title"), setting.data.brand_list_setting.title_setting.align);
}

var al_title = document.createTextNode(setting.data.alphabet_list_setting.title_setting.label);
if(document.getElementById("alphabet-list-title") != null) {
  document.getElementById("alphabet-list-title").appendChild(al_title);
  if(setting.data.alphabet_list_setting.title_setting.font_bold) {
      document.getElementById("alphabet-list-title").classList.add("aht-bold");
    }
  get_position(document.getElementById("alphabet-list-title"), setting.data.alphabet_list_setting.title_setting.align);
}

// Alphabet section
var alphabet = setting.data.alphabet_list_setting.general_setting.alphabet.toUpperCase().split(',');
 alphabet = Array.from(new Set(alphabet));


var alphabet_list = [];
        alphabet.map((value, index) => {
          if (value != '') {
            const check_exist = brands_new
              .filter(brand => {

                return brand.brand_id.brand_name.charAt(0).toLowerCase().indexOf(value.toLowerCase()) >= 0;

              })

            if (check_exist.length > 0) {
                alphabet_list.push({'character': value, 'brand': check_exist});
            };
          }
        })       


function render_alphabet_list() {
  var root = document.getElementById('aht-alphabet-list');
      const div_root = document.createElement("div");
    div_root.setAttribute("class", "aht-row-wrapper aht-row-mobile-2");
    if (setting.data.brand_list_setting.general_setting.character_per_row > 4) {
      div_root.classList.add("aht-row-tablet-4");
      div_root.classList.add("aht-row-"+setting.data.alphabet_list_setting.general_setting.character_per_row);
    } else {
      div_root.classList.add("aht-row-tablet-"+setting.data.alphabet_list_setting.general_setting.character_per_row);
      div_root.classList.add("aht-row-"+setting.data.alphabet_list_setting.general_setting.character_per_row);
    }
    root.appendChild(div_root);
    alphabet_list.map((value, index) => {
       const div_brand = document.createElement("div");
       div_brand.setAttribute("class", "aht-row-wrapper aht-row-mobile-2");
       if (setting.data.brand_list_setting.general_setting.brand_per_row > 4) {
         div_brand.classList.add("aht-row-tablet-4");
         div_brand.classList.add("aht-row-"+setting.data.alphabet_list_setting.general_setting.brand_per_row);
       } else {
         div_brand.classList.add("aht-row-tablet-"+setting.data.alphabet_list_setting.general_setting.brand_per_row);
         div_brand.classList.add("aht-row-"+setting.data.alphabet_list_setting.general_setting.brand_per_row);
       }
        

       var div_row = document.createElement('div');
       div_row.setAttribute('class', 'aht-grid');

       var div_info = document.createElement('div');
       div_info.setAttribute('class', 'aht-alphabet-list-content');

       var div_letter = document.createElement('div');
       div_letter.setAttribute('class', 'aht-alphabet-letter');
       div_letter.setAttribute('id', 'Character'+value.character);
    
       var div_name = document.createElement('div');
       div_name.setAttribute('class', 'aht-brand-name aht-center');

       var character = document.createTextNode(value.character);
       div_letter.appendChild(character);
       if (value.brand.length <= setting.data.alphabet_list_setting.general_setting.brand_per_character) {
         
            div_letter.setAttribute('data-current-brand', value.brand.length);
            value.brand.map((brands, index) => {   

                 var li_item = document.createElement('div');
                 li_item.setAttribute('class', 'aht-alphabet-brand');
                 var a_logo =  document.createElement('a');
                 a_logo.setAttribute('class', 'aht-brand-list-item');
                 a_logo.setAttribute('href', '/pages/'+ page_title.data.url_key+'/'+brands.brand_id.brand_key);

                 var brandName = document.createTextNode(brands.brand_id.brand_name);


                 a_logo.appendChild(brandName);
                 li_item.appendChild(a_logo);
                 div_brand.appendChild(li_item);
            });
       } else {
         div_letter.setAttribute('data-current-brand', setting.data.alphabet_list_setting.general_setting.brand_per_character);
            value.brand.slice(0,setting.data.alphabet_list_setting.general_setting.brand_per_character).map((brands, index) => {   
              var li_item = document.createElement('div');
              li_item.setAttribute('class', 'aht-alphabet-brand');
              var a_logo =  document.createElement('a');
              a_logo.setAttribute('class', 'aht-brand-list-item');
              a_logo.setAttribute('href', '/pages/'+ page_title.data.url_key+'/'+brands.brand_id.brand_key);

              var brandName = document.createTextNode(brands.brand_id.brand_name);


              a_logo.appendChild(brandName);
              li_item.appendChild(a_logo);
              div_brand.appendChild(li_item);
            });
            var li_item = document.createElement('div');
            li_item.setAttribute('class', 'aht-alphabet-brand');
            var a_logo =  document.createElement('a');
            a_logo.setAttribute('id', 'loadmore'+value.character);
            a_logo.setAttribute('class', 'aht-brand-list-item');
            a_logo.addEventListener("click", function(){ 
            var character = this.getAttributeNode("id").value.slice((parseInt(this.getAttributeNode("id").value.length)-8)* -1);
            var number = document.getElementById("Character"+character).getAttributeNode("data-current-brand").value;

            if (parseInt(number) <= value.brand.length ) {
              value.brand.slice(parseInt(number), parseInt(number) + 1 ).map((brands, index) => {   
                var li_item = document.createElement('div');
                li_item.setAttribute('class', 'aht-alphabet-brand');
                var a_logo =  document.createElement('a');
                a_logo.setAttribute('class', 'aht-brand-list-item');
                var brandName = document.createTextNode(brands.brand_id.brand_name);
                a_logo.appendChild(brandName);
                li_item.appendChild(a_logo);
                div_brand.insertBefore(li_item, div_brand.childNodes[parseInt(number)]);
              });
              document.getElementById("Character"+character).setAttribute("data-current-brand", parseInt(number) + 1); 
              if (parseInt(number) + 1 >= value.brand.length) {
                  this.style.display = 'none'
              }
            }  
          });
          var brandName = document.createTextNode(setting.data.alphabet_list_setting.general_setting.viewmore_text);

          a_logo.appendChild(brandName);
          li_item.appendChild(a_logo);
          div_brand.appendChild(li_item);
        };
        div_row.appendChild(div_brand);
        div_info.appendChild(div_letter); 
        div_info.appendChild(div_row); 
        div_root.appendChild(div_info);
   });
}

if (page_title.data.alphabet_list == '1' &&document.getElementById("template-alphabet-list") ) {
    render_alphabet_list();
}

// Search box
function autocomplete(inp, arr) {
  var currentFocus;
  inp.addEventListener("input", function(e) {
      var a, b, i, val = this.value;
      closeAllLists();
      if (!val) { return false;}
      currentFocus = -1;
      a = document.createElement("DIV");
      a.setAttribute("id",  "autocomplete-list");
      a.setAttribute("class", "aht-suggestion-container");
      var list_root = document.getElementById("aht-search");
      list_root.appendChild(a);
      var brand = 0;
      for (i = 0; i < arr.length; i++) { 
        var data = arr[i].brand_id.brand_name.toUpperCase();
        var compare = val.toUpperCase();
        if (data.includes(compare)) {
          b = document.createElement("DIV");
          b.setAttribute("class", "aht-suggestion-brand-name");
          if (setting.data.search_box_setting.search_suggest_setting.br_font_bold) {
            b.innerHTML = makeBold(arr[i].brand_id.brand_name, val);
          }
          var div_left = document.createElement("DIV");
          div_left.setAttribute("class", "aht-suggestion-left");
          
          var div_right = document.createElement("div");
          div_right.setAttribute("class", "aht-suggestion-right");
          
          var a_brand = document.createElement("a");
          a_brand.setAttribute("href", '/pages/'+ page_title.data.url_key+"/"+arr[i].brand_id.brand_key);
          
          var div = document.createElement("div");
          div.setAttribute("class","aht-autocomplete-suggestion ");
          
          
          var img_brand = document.createElement("img");
          img_brand.setAttribute("src", arr[i].brand_id.brand_logo);
          img_brand.setAttribute("alt", arr[i].brand_id.meta_keyword);
          
          var p = document.createElement("div");
          p.setAttribute("class", "aht-suggestion-shortdes");
          
          var shortdes = document.createTextNode(arr[i].brand_id.short_description);
          p.appendChild(shortdes);
          if (setting.data.search_box_setting.search_suggest_setting.show_short_description) {
          div_right.appendChild(b);
          }
          if (setting.data.search_box_setting.search_suggest_setting.show_brand_name) {
          div_right.appendChild(p);
          }
          if (setting.data.search_box_setting.search_suggest_setting.show_brand_image) {
          div_left.appendChild(img_brand);
          }
          
          a_brand.appendChild(div_left);
          a_brand.appendChild(div_right);
          div.appendChild(a_brand);
          a.appendChild(div);
          
          div.addEventListener("click", function(e) {
            window.location.href = ""+this.getElementsByTagName("a")[0].href;
              closeAllLists();
          });
        }        
        else {
          brand = brand+1;
          if (brand == arr.length){
            z = document.createElement("DIV");
            a.setAttribute("class", "aht-suggestion-container aht-initial");
            z.innerHTML = "There is no brand match your require";
            a.appendChild(z);
          }
        }
      }
  });
  inp.addEventListener("keydown", function(e) {

      var x = document.getElementById("autocomplete-list");
      if (x) x = x.getElementsByClassName("aht-autocomplete-suggestion");
      if (e.keyCode == 40) {
        currentFocus++;
        addActive(x);
      } else if (e.keyCode == 38) {
        currentFocus--;
        addActive(x);
      } else if (e.keyCode == 13) {
        e.preventDefault();
        if (currentFocus > -1) {
          if (x) x[currentFocus].click();
        }
      }
  });
  function addActive(x) {
    if (!x) return false;
    removeActive(x);
    if (currentFocus >= x.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = (x.length - 1);
    x[currentFocus].classList.add("autocomplete-active");
  }
  function removeActive(x) {
    for (var i = 0; i < x.length; i++) {
      x[i].classList.remove("autocomplete-active");
    }
  }
  function closeAllLists(elmnt) {
    var x = document.getElementsByClassName("aht-suggestion-container");
    for (var i = 0; i < x.length; i++) {
      if (elmnt != x[i] && elmnt != inp) {
        x[i].parentNode.removeChild(x[i]);
      }
    }
  }
  document.addEventListener("click", function (e) {
      closeAllLists(e.target);
  });
}
    if (document.getElementById("template-search-box")){
      document.getElementById("aht-brand").placeholder = setting.data.search_box_setting.search_input_setting.placeholder; 
      autocomplete(document.getElementById("aht-brand"), brands_new);
      get_position(document.getElementById("template-search-box"), setting.data.search_box_setting.general_setting.content_align)
    }
function makeBold(input, wordsToBold) {
  return input.replace(new RegExp('(' + wordsToBold + ')','ig'), '<b>$1</b>');
}

// End of search box

//Brand list
function render_brand_list(start, end) {
    const div_row = document.getElementById("aht-bl-row-wrapper");

    brands_new.slice(start, end).map((brand, index) => {   
      var li_item = document.createElement('div');
      li_item.setAttribute('class', 'aht-brand-list-item');

      var img_brand = document.createElement("img");
      img_brand.setAttribute("src", brand.brand_id.brand_logo);
      img_brand.setAttribute("alt", brand.brand_id.meta_keyword);


       var a_logo =  document.createElement('a');
       a_logo.setAttribute('href', '/pages/'+ page_title.data.url_key+'/'+brand.brand_id.brand_key);

       var a_img =  document.createElement('a');
       a_img.setAttribute('class', 'aht-brand-img');
       a_img.setAttribute('href', '/pages/'+ page_title.data.url_key+'/'+brand.brand_id.brand_key);

      var div_details = document.createElement("div");
      div_details.setAttribute("class", "aht-brand-details");

      var div_name = document.createElement("div");
      div_name.setAttribute("class", "aht-brand-name");

      var div_wrapper = document.createElement("div");
      div_wrapper.setAttribute("class", "aht-image-wrapper "+ setting.data.brand_list_setting.general_setting.hover_effect);
      if (setting.data.brand_list_setting.brand_name_setting.auto_hide && setting.data.brand_list_setting.brand_name_setting.position == 1) {
          div_wrapper.classList.add("aht-auto-hide");
      } else {
          div_wrapper.classList.add("aht-normal-image")
      }
      

      if (setting.data.brand_list_setting.brand_name_setting.position == 1) {
        div_wrapper.classList.add("brand-inside");
      } else {
        div_wrapper.classList.add("brand-below");
      }

      var div_info = document.createElement("div");
      div_info.setAttribute("class", "aht-brand-info");

      var brandName = document.createTextNode(brand.brand_id.brand_name);

      var span_name = document.createElement("span");
      span_name.setAttribute("class", "aht-brand-name");          

      var span_pc = document.createElement("span");
      span_pc.setAttribute("class", "aht-product-count");
      span_name.setAttribute("dir", "auto"); 
      span_pc.setAttribute("dir", "auto");
      if (setting.data.featured_brand_setting.brand_name_setting.pc_position == 2) {
        span_pc.classList.add("below");
      } else {
        span_pc.classList.add("inline");
      }

      var productCount = document.createTextNode(setting.data.brand_list_setting.brand_name_setting.pc_text_format.replace('%s',brand.products? brand.products.length : 0))
      span_pc.appendChild(productCount);
    
      span_name.appendChild(brandName)
      a_logo.appendChild(span_name);


      if(setting.data.brand_list_setting.brand_name_setting.display_product_count) {
                 a_logo.appendChild(span_pc);
      }          
       a_img.appendChild(img_brand);
       div_name.appendChild(a_logo);
       div_details.appendChild(div_name);
       get_position(div_details, setting.data.brand_list_setting.brand_name_setting.text_align);

       div_wrapper.appendChild(a_img);
       div_wrapper.appendChild(div_details);
       div_info.appendChild(div_wrapper);
       li_item.appendChild(div_info)
       div_row.appendChild(li_item);
})

}

                    
function render_all() {
   const div_root = document.getElementById("brand-list-row");
   const ul = document.getElementById("aht-brand-list-content");
   const div_row = document.createElement("div");
    div_row.setAttribute("class", "aht-row-wrapper aht-row-mobile-2");
    div_row.setAttribute("id", "aht-bl-row-wrapper");
    if (setting.data.brand_list_setting.general_setting.brand_per_row > 4) {
      div_row.classList.add("aht-row-tablet-4");
      div_row.classList.add("aht-row-"+setting.data.brand_list_setting.general_setting.brand_per_row);
    } else {
      div_row.classList.add("aht-row-tablet-"+setting.data.brand_list_setting.general_setting.brand_per_row);
      div_row.classList.add("aht-row-"+setting.data.brand_list_setting.general_setting.brand_per_row);
    }
 
    ul.appendChild(div_row);
        if(brands_new.length <= setting.data.brand_list_setting.general_setting.limit ) {
          render_brand_list( 0, setting.data.brand_list_setting.general_setting.limit);
        } else {
            render_brand_list(0,  setting.data.brand_list_setting.general_setting.limit);
            var my_icon = document.createElement("i");
            my_icon.setAttribute("class", "fa left-10 fa-angle-double-right");
            my_icon.setAttribute("aria-hidden", true);

            var button_viewmore = document.createElement("button");
            button_viewmore.setAttribute("class", "btn-viewmore");
            button_viewmore.setAttribute("type", "submit");
            button_viewmore.setAttribute("id", "hoverLoadMore");
            button_viewmore.setAttribute("data-load", setting.data.brand_list_setting.general_setting.limit);
            button_viewmore.addEventListener("click", function(){ 
              var load_current =parseInt(this.getAttributeNode("data-load").value);
              render_brand_list( load_current , load_current + parseInt(setting.data.brand_list_setting.general_setting.load_limit) );
              this.setAttribute("data-load", load_current + parseInt(setting.data.brand_list_setting.general_setting.load_limit) );
              if(load_current + parseInt(setting.data.brand_list_setting.general_setting.load_limit) >= parseInt(brands_new.length)) {
                button_viewmore.style.display = "none"
              }
            });


            var brandName = document.createTextNode(setting.data.brand_list_setting.general_setting.loadmore_text);
            button_viewmore.appendChild(brandName);
            button_viewmore.appendChild(my_icon);
            if(setting.data.brand_list_setting.general_setting.loadmore_font_bold) {
              button_viewmore.classList.aht("font-bold");
            }
            div_root.appendChild(button_viewmore);
        }

}


if (page_title.data.brand_list == '1' && document.getElementById("template-brand-list")) {
 
    render_all();
}
//End of brand list

// Feature brand
   
var feature_brand = brands_new.filter(function(brand) {
if (brand.brand_id.is_feature == false) {
    return false; 
  }
  return true;
});

if(document.getElementById("featured-brand-title")) {
  if (feature_brand.length) {
    document.getElementById("featured-brand-title").appendChild(fb_title);
    if(setting.data.featured_brand_setting.title_setting.font_bold) {
      document.getElementById("featured-brand-title").classList.add("aht-bold");
    }
    get_position(document.getElementById("featured-brand-title"), setting.data.featured_brand_setting.title_setting.align);
  } else {
    document.getElementById("featured-brand-title").style.display = "none";
  }
}


jq213 = jQuery.noConflict( true );
function sliderInit(){
    const number = (setting.data.featured_brand_setting.brand_setting.brand_per_row >= feature_brand.length) ? ((feature_brand.length - 1 == 0)? 1 :  feature_brand.length - 1 ): setting.data.featured_brand_setting.brand_setting.brand_per_row;
    const tablet_number = (setting.data.featured_brand_setting.brand_setting.brand_per_row >= feature_brand.length)? ( (feature_brand.length <= 4 ) ? ((feature_brand.length - 1 == 0)? 1 : feature_brand.length - 1) : 4) : ((setting.data.featured_brand_setting.brand_setting.brand_per_row <= 4 ) ? ((setting.data.featured_brand_setting.brand_setting.brand_per_row - 1 == 0)? 1 : setting.data.featured_brand_setting.brand_setting.brand_per_row) : 4);
    const mobile_number = (feature_brand.length <= 2 && setting.data.featured_brand_setting.brand_setting.brand_per_row <= 2) ? 1 : 2;
    jq213('#aht-featured-brand-content').slick(
    {
        slidesToShow: number,
        slidesToScroll: setting.data.featured_brand_setting.brand_setting.slide_by,
        rtl: setting.data.featured_brand_setting.brand_setting.rtl,
        infinite: setting.data.featured_brand_setting.brand_setting.loop,
        arrows: (feature_brand.length)? setting.data.featured_brand_setting.brand_setting.display_navigation : false,
        dots: (feature_brand.length)? setting.data.featured_brand_setting.brand_setting.display_Pagination : false,
        prevArrow: `<div class="slick-arrow rtl slick-prev" id="aht-arrow-prev"></div>`,
        nextArrow: `<div class="slick-arrow rtl slick-next" id="aht-arrow-next"></div>`,
        autoplay: setting.data.featured_brand_setting.brand_setting.autoplay,
        speed: 1000,
        autoplaySpeed: setting.data.featured_brand_setting.brand_setting.autoplay_timeout,
        dotsClass: "aht-slick-dots",
        customPaging: function(slick,index) {
            return '<div class="slick-dot" ></div>';
        },
        responsive: [
        {
            breakpoint: 980, // tablet breakpoint
            settings: {
                slidesToShow: tablet_number,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480, // mobile breakpoint
            settings: {
                slidesToShow: mobile_number,
                slidesToScroll: 1
            }
        }
    ]
    });

    switch(number) {
      case 1:
        document.getElementById("aht-featured-brand-content").style.width = '20%';
        break;
      case 2:
        document.getElementById("aht-featured-brand-content").style.width = '40%';
        break;
      case 3:
        document.getElementById("aht-featured-brand-content").style.width = '60%';
        break;
      case 4:
        document.getElementById("aht-featured-brand-content").style.width = '80%';
        break;
      default: 
        document.getElementById("aht-featured-brand-content").style.width = '100%';
        break;
    }
};


jq213(document).on('ready', function () {
  if (setting.data.featured_brand_setting.brand_setting.use_slider){
   sliderInit();
    if (setting.data.featured_brand_setting.brand_setting.hide_navigation && document.getElementById("aht-arrow-prev")) {
      document.getElementById("aht-arrow-prev").classList.add("hide-navigation");
      document.getElementById("aht-arrow-next").classList.add("hide-navigation");
    };
    if (document.getElementById("aht-arrow-prev")) {
      if(setting.data.featured_brand_setting.brand_setting.navigation_position == 2) {
        document.getElementById("aht-arrow-prev").classList.add("outside-arrow");
        document.getElementById("aht-arrow-next").classList.add("outside-arrow");
      } else{
        document.getElementById("aht-arrow-prev").classList.add("inside-arrow");
        document.getElementById("aht-arrow-next").classList.add("inside-arrow");
      }
    };
  } else {
    document.getElementById("aht-featured-brand-content").classList.add("aht-grid");
  }
});
function get_featured_brand() {
  const div_origin = document.getElementById("aht-featured-brand-content");
  if (setting.data.featured_brand_setting.brand_setting.rtl && setting.data.featured_brand_setting.brand_setting.use_slider) {
    div_origin.setAttribute("dir","rtl");
  }

  if (setting.data.featured_brand_setting.brand_setting.use_slider) {
      feature_brand.slice(0, setting.data.featured_brand_setting.brand_setting.limit ).map((brand, index) => {  
        var li_item = document.createElement('div');
        li_item.setAttribute('class', 'aht-fb-item');
        if (setting.data.featured_brand_setting.brand_setting.rtl && setting.data.featured_brand_setting.brand_setting.use_slider) {
              li_item.setAttribute('dir','rtl');
        }
        var img_brand = document.createElement("img");
        img_brand.setAttribute("src", brand.brand_id.brand_logo);
        img_brand.setAttribute("alt", brand.brand_id.meta_keyword);

            
         var a_logo =  document.createElement('a');
         a_logo.setAttribute('href', '/pages/'+ page_title.data.url_key+'/'+brand.brand_id.brand_key);

         var a_img =  document.createElement('a');
         a_img.setAttribute('class', 'aht-brand-img');
         a_img.setAttribute('href', '/pages/'+ page_title.data.url_key+ '/'+brand.brand_id.brand_key);

        var div_details = document.createElement("div");
        div_details.setAttribute("class", "aht-brand-details");

        var div_name = document.createElement("div");
        div_name.setAttribute("class", "aht-brand-name");

        var div_wrapper = document.createElement("div");
        div_wrapper.setAttribute("class", "aht-image-wrapper "+ setting.data.featured_brand_setting.brand_setting.hover_efect);
        if (setting.data.featured_brand_setting.brand_name_setting.auto_hide && setting.data.featured_brand_setting.brand_name_setting.position == 1) {
            div_wrapper.classList.add("aht-auto-hide");
        }
        

        if (setting.data.featured_brand_setting.brand_name_setting.position == 1) {
            div_wrapper.classList.add("brand-inside");
        } else {
            div_wrapper.classList.add("brand-below");
        }

        var div_info = document.createElement("div");
        div_info.setAttribute("class", "aht-brand-info");

        var span_name = document.createElement("span");
        span_name.setAttribute("class", "aht-brand-name"); 
        span_name.setAttribute("dir", "auto"); 

        var span_pc = document.createElement("span");
        span_pc.setAttribute("class", "aht-product-count");
        span_pc.setAttribute("dir", "auto");

        if (setting.data.featured_brand_setting.brand_name_setting.pc_position == 2) {
          span_pc.classList.add("below");
        } else {
          span_pc.classList.add("inline");
        }

        var brandName = document.createTextNode(brand.brand_id.brand_name+ " ");

        var productCount = document.createTextNode(setting.data.featured_brand_setting.brand_name_setting.pc_text_format.replace('%s',brand.products? brand.products.length : 0))
        span_pc.appendChild(productCount);
        
        span_name.appendChild(brandName)
        a_logo.appendChild(span_name);


        if(setting.data.featured_brand_setting.brand_name_setting.display_product_count) {
                   a_logo.appendChild(span_pc);
        }            
         a_img.appendChild(img_brand);
         div_details.appendChild(div_name);
         div_name.appendChild(a_logo);
         div_wrapper.appendChild(a_img);
        if(setting.data.featured_brand_setting.brand_name_setting.display){
            div_wrapper.appendChild(div_details);
            get_position(div_details, setting.data.featured_brand_setting.brand_name_setting.text_align);
          }


         div_info.appendChild(div_wrapper);
         li_item.appendChild(div_info);
         div_origin.appendChild(li_item);
    });
  } else {
    const div_row = document.createElement("div");
    div_row.setAttribute("class", "aht-row-wrapper aht-row-mobile-2");
    if (setting.data.featured_brand_setting.brand_setting.brand_per_row > 4) {
      div_row.classList.add("aht-row-tablet-4");
      div_row.classList.add("aht-row-"+setting.data.featured_brand_setting.brand_setting.brand_per_row);
    } else {
      div_row.classList.add("aht-row-tablet-"+setting.data.featured_brand_setting.brand_setting.brand_per_row);
      div_row.classList.add("aht-row-"+setting.data.featured_brand_setting.brand_setting.brand_per_row);
    }
 
    div_origin.appendChild(div_row);
    feature_brand.slice(0, setting.data.featured_brand_setting.brand_setting.limit ).map((brand, index) => {  
      var li_item = document.createElement('div');
       li_item.setAttribute('class', 'aht-fb-item');

      var img_brand = document.createElement("img");
      img_brand.setAttribute("src", brand.brand_id.brand_logo);
      img_brand.setAttribute("alt", brand.brand_id.meta_keyword);

          
       var a_logo =  document.createElement('a');
       a_logo.setAttribute('href','/pages/'+ page_title.data.url_key+'/'+brand.brand_id.brand_key);

       var a_img =  document.createElement('a');
       a_img.setAttribute('class', 'aht-brand-img');
       a_img.setAttribute('href', '/pages/'+ page_title.data.url_key+'/'+brand.brand_id.brand_key);

      var div_details = document.createElement("div");
      div_details.setAttribute("class", "aht-brand-details");

      var div_name = document.createElement("div");
      div_name.setAttribute("class", "aht-brand-name");

      var div_wrapper = document.createElement("div");
      div_wrapper.setAttribute("class", "aht-image-wrapper "+ setting.data.featured_brand_setting.brand_setting.hover_efect);
      if (setting.data.featured_brand_setting.brand_name_setting.auto_hide && setting.data.featured_brand_setting.brand_name_setting.position == 1) {
          div_wrapper.classList.add("aht-auto-hide");
      }

      if (setting.data.featured_brand_setting.brand_name_setting.position == 1) {
          div_wrapper.classList.add("brand-inside");
      } else {
          div_wrapper.classList.add("brand-below");
      }

      var div_info = document.createElement("div");
      div_info.setAttribute("class", "aht-brand-info");

      var brandName = document.createTextNode(brand.brand_id.brand_name);

      var span_name = document.createElement("span");
      span_name.setAttribute("class", "aht-brand-name");          

      var span_pc = document.createElement("span");
      span_pc.setAttribute("class", "aht-product-count");
      
      span_name.setAttribute("dir", "auto"); 
      span_pc.setAttribute("dir", "auto");

      if (setting.data.featured_brand_setting.brand_name_setting.pc_position == 2) {
        span_pc.classList.add("below");
      } else {
        span_pc.classList.add("inline");
      }

      var productCount = document.createTextNode(setting.data.featured_brand_setting.brand_name_setting.pc_text_format.replace('%s',brand.products? brand.products.length : 0))
      span_pc.appendChild(productCount);
    
      span_name.appendChild(brandName)
      a_logo.appendChild(span_name);
  
      if(setting.data.featured_brand_setting.brand_name_setting.display_product_count) {
                 a_logo.appendChild(span_pc);
      }            
       a_img.appendChild(img_brand);
       div_details.appendChild(div_name);
       div_name.appendChild(a_logo);
         div_wrapper.appendChild(a_img);
      if(setting.data.featured_brand_setting.brand_name_setting.display){
          div_wrapper.appendChild(div_details);
          get_position(div_details, setting.data.featured_brand_setting.brand_name_setting.text_align);
      }
      div_info.appendChild(div_wrapper);
      li_item.appendChild(div_info);
      div_row.appendChild(li_item);
    });
  }

}
if (page_title.data.featured_brand == '1' && document.getElementById("template-featured-brand") ) {
    get_featured_brand();
}

                